// ChatStyles.js

const ChatStyles = {
    app: {
      display: "flex",
      flexDirection: "column",
      height: "88vh",
      overflow: "hidden",
      backgroundColor: "#343541",
      color: "#ececf1",
    },
    header: {
      padding: "1rem",
      backgroundColor: "#f3f3f3",
      display: "flex",
      alignItems: "flex-start",
      gap: "0.5rem",
    },
    headerButton: {
      color: "#5A954A",
      background: "none",
      border: "none",
      cursor: "pointer",
      alignSelf: "flex-start",
      margin: 0,
      padding: 0,
      fontSize: "24px",
    },
    messageListContainer: {
      flexGrow: 1,
      overflowY: "auto",
      padding: "1rem 0",
      backgroundColor: "#f3f3f3",
    },
    innerContainer: {
      maxWidth: "820px",
      margin: "0 auto",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },
    message: {
      width: "100%",
      padding: "0.8rem 1rem",
      borderRadius: "8px",
      whiteSpace: "pre-wrap",
    },
    userMessage: {
      backgroundColor: "#d3eaff",
      color: "#000",
    },
    assistantMessage: {
      backgroundColor: "#f0f0f0",
      color: "#000",
    },
    inputContainer: {
      padding: "1rem",
      borderTop: "1px solid #40414f",
      backgroundColor: "#f3f3f3",
      position: "sticky",
      bottom: 0,
      width: "100%",
      zIndex: 10,
    },
    inputForm: {
      display: "flex",
      alignItems: "flex-end",
      backgroundColor: "#d9d9d9",
      borderRadius: "10px",
      padding: "0.75rem 1rem",
      position: "relative",
      width: "100%",
    },
    textarea: {
      flex: 1,
      background: "transparent",
      border: "none",
      resize: "none",
      color: "#000",
      outline: "none",
      paddingRight: "3rem",
      height: "52px",
    },
    sendButton: {
      background: "none",
      border: "none",
      padding: 0,
      cursor: "pointer",
      position: "absolute",
      right: "1rem",
      bottom: "1rem",
      color: "#5A954A",
      transition: "color 0.2s ease",
    },
    suggestionsContainer: {
      padding: "1rem",
      display: "flex",
      gap: "0.75rem",
      flexWrap: "wrap",
      justifyContent: "center",
      backgroundColor: "#343541",
    },
    suggestionBtn: {
      background: "#2b2c2f",
      border: "none",
      padding: "0.6rem 1rem",
      borderRadius: "20px",
      cursor: "pointer",
      color: "#ececf1",
      transition: "background 0.3s ease",
    },
    suggestionBtnHover: {
      background: "#444654",
    },

    iconWrapper: {
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "32px",
      paddingTop: "6px",
      paddingLeft:"10px"
    },
    
    userIcon: {
      fontSize: "28px",
      color: window._env_.Color1,  
    },
    
    botIcon: {
      fontSize: "28px",
      color: window._env_.Color1,  
    },

    

  };
  
  export default ChatStyles;
  